<template>
   <div class="btn-group">
      <button @click="changeOptions('table')"
            id="table"
            type="button"
            class="btn"
            :class="{'btn-active': !isKanban, 'btn':isKanban}">
         <i class="fa fa-bars"  aria-hidden="true"></i> LISTA
      </button>
      <button
            @mouseover="hoverIcon = true"
            @mouseleave="hoverIcon = false"
            @click="changeOptions('kanban')"
            id="kanban"
            type="button"
            class="btn"
            :class="{'btn-active': isKanban, 'btn':!isKanban }">
         <img class="icon-kanban"  :class="{'icon-kanban-active':isKanban}" :src="getIconSrc" />
         KANBAN
      </button>
   </div>
</template>

<script>
import groupbuttonocurrence from './groupbuttonocurrence'
export default groupbuttonocurrence
</script>

<style scoped>
.btn{
   width: 8rem;
   color:#008148;
   background-color: #ffffff;
   font-family: 'Segoe UI';
   font-weight: bold;
   /* border-color:#949494; */

   border: 1px solid #949494;
}
.btn:active {
   background-color:#008148;
   color: #ffffff;
}
.btn:hover{
   color:#ffffff;
   background:#008148;
}
.btn-active{
   width: 8rem;
   background-color:#008148;
   color: #ffffff;
   font-family: 'Segoe UI';
   font-weight: bold;
   border-color:#949494;
}

.icon-kanban-active{
   filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(303deg) brightness(103%) contrast(101%);
}
/*
.fa-bars:active{
   background:#ffffff;
}

.btn-teste-active{
   background-color: #008148;
   color:#ffffff;
}
.btn-teste:active{
   background-color: #008148;
   color: #e9ecef;
}
.btn-teste{
   background-color: #ffffff;
   border-color: #e9ecef;
   color: #008148;
}
.btn-teste:hover {
   color: #008148;
   background-color: #008148;
   color: #e9ecef;
}
.btn:focus{
   color: #e9ecef;
}
.btn-teste:active{
   color: #e9ecef;
   background-color: #008148;
   border-color: #008148;
}
.btn-teste:focus,
.btn-teste.focus {
   box-shadow: #008148;
   color:#e9ecef;
}
.fa-bars{
   color: black;
}
.button-list-kanban-left{
   border: 1px;
   border-bottom-left-radius: 20%;
   border-top-left-radius: 20%;
   background-color: white;
   width: 25px;
   height: 25px;
   margin-left: 0;
}

.button-list-kanban-right{
   border: 1px;
   border-bottom-right-radius: 20%;
   border-top-right-radius: 20%;
   background-color: #e9ecef;
   width: 25px;
   height: 25px;
   margin-right: 0;
}

   .iconedoKanban{
      fill: #ffffff;
   }
   .icon-kanban:hover{
      stroke: #fff;
   }
   */
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/groupbuttonocurrence/groupbuttonocurrence.vue